import React, { Component } from 'react';
import { checkLoginStatus, getUser, getDeviceTypeInfo, getProject } from '../helpers/helper.js';
import SignIn from './SignIn.jsx';
import LoadingScreen from './LoadingScreen';
import MainLayout from './MainLayout';
import jwt from 'jsonwebtoken';

export default class Root extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loggedInStatus: 'NOT_LOGGED_IN',
            user: JSON.parse(localStorage.getItem('user')),
            projectId: localStorage.getItem('currentProjectId'),
            projects: JSON.parse(localStorage.getItem('projects')),
        };

        this.handleLogin = this.handleLogin.bind(this);
    }

    /**
     * Funzione di gestione stato utente loggato
     * @param {*} data
     */
    async handleLogin(data) {
        if (data.loggedInStatus === "LOGGED_IN" && this.state.user === null) {
            let token = localStorage.getItem('access_token');
            let decodedToken = jwt.decode(token, { complete: true });
            let uuid = decodedToken.payload.id;

            try {
                const userRes = await getUser(uuid);
                if (userRes.data) {
                    localStorage.setItem('user', JSON.stringify(userRes.data.rows[0]));
                    localStorage.setItem('userId', userRes.data.rows[0].id);
                    this.setState({ user: userRes.data.rows[0] });
                }
                // Dopo di che prende l'utente prende anche il project
                const projectRes = await getProject();
                    if (projectRes.data) {
                        const projects = projectRes.data.rows;
                        const currentProjectId = projects.length > 0 ? projects[0].uuid : null;

                        localStorage.setItem('currentProjectId', currentProjectId);
                        localStorage.setItem('projects', JSON.stringify(projects));

                        this.setState({ projectId: currentProjectId, projects, loggedInStatus: "LOGGED_IN" });
                    }

                const deviceTypeInfoRes = await getDeviceTypeInfo();
                localStorage.setItem("deviceTypeInfo", JSON.stringify(deviceTypeInfoRes.data.rows));
            } catch (err) {
                console.error(err);
            }
        } else {
            this.setState(data);
        }
    }

    componentDidMount() {
        this.setState({ loading: false }, () => {
            checkLoginStatus(this.handleLogin);
        });
    }

    render() {
        if (this.state.loading) {
            return <LoadingScreen />;
        } else if (this.state.loggedInStatus !== 'LOGGED_IN') {
            return <SignIn updateLoginState={this.handleLogin} />;
        } else {
            return <MainLayout updateLoginState={this.handleLogin} app={this.state} />;
        }
    }
}
